import request from '@/utils/request'

export const permissionApi = {
  // 获取当前用户权限（前端核心接口）
  getUserPermissions() {
    return request({
      url: '/inventory-management-api/permission/userPermissions',
      method: 'POST',
      data: {}
    })
  },

  // 获取所有权限树
  getPermissionTree() {
    return request({
      url: '/inventory-management-api/permission/tree',
      method: 'POST',
      data: {}
    })
  },

  // 新增权限/菜单
  createPermission(data) {
    return request({
      url: '/inventory-management-api/permission/create',
      method: 'POST',
      data
    })
  },

  // 修改权限/菜单
  updatePermission(data) {
    return request({
      url: '/inventory-management-api/permission/update',
      method: 'POST',
      data
    })
  },

  // 删除权限/菜单
  deletePermission(data) {
    return request({
      url: '/inventory-management-api/permission/delete',
      method: 'POST',
      data
    })
  },

  // 获取角色列表
  getRoleList() {
    return request({
      url: '/inventory-management-api/permission/role/list',
      method: 'POST',
      data: {}
    })
  },

  // 创建角色
  createRole(data) {
    return request({
      url: '/inventory-management-api/permission/role/create',
      method: 'POST',
      data
    })
  },

  // 修改角色
  updateRole(data) {
    return request({
      url: '/inventory-management-api/permission/role/update',
      method: 'POST',
      data
    })
  },

  // 删除角色
  deleteRole(data) {
    return request({
      url: '/inventory-management-api/permission/role/delete',
      method: 'POST',
      data
    })
  },

  // 给用户分配角色
  assignUserRoles(data) {
    return request({
      url: '/inventory-management-api/permission/user/assignRoles',
      method: 'POST',
      data
    })
  },

  // 查询用户角色
  getUserRoles(data) {
    return request({
      url: '/inventory-management-api/permission/user/roles',
      method: 'POST',
      data
    })
  },

  // 获取用户列表
  getAccountList() {
    return request({
      url: '/inventory-management-api/permission/account/list',
      method: 'POST',
      data: {}
    })
  },

  // 创建用户
  createAccount(data) {
    return request({
      url: '/inventory-management-api/permission/account/create',
      method: 'POST',
      data
    })
  },

  // 修改用户
  updateAccount(data) {
    return request({
      url: '/inventory-management-api/permission/account/update',
      method: 'POST',
      data
    })
  },

  // 禁用/启用用户
  toggleAccountStatus(data) {
    return request({
      url: '/inventory-management-api/permission/account/toggleStatus',
      method: 'POST',
      data
    })
  }
}
